
import moment from 'moment';
import { getData, getTimestampData } from '@/components/report/service';
import { crudRequest2 } from '@/services/api';
import { VolumesQuery } from '../Sql';
import { SqlBase } from '../../../common';

export default {
  namespace: 'centerDepartBoardVolumesModal',
  state: {
    // 线路发出量
    totalData: [],
    // 类型
    productData: [],
    // 线路运力与实际发件量对比
    volumesData: [],

    volumes: {}, // 运力
  },
  effects: {
    // 重置
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          totalData: [],
          productData: [], 
          volumesData: []
        },
      });
    },
    *getSelect(_, { put }) {
      yield put({ type: 'getSiteDepart' });
      yield put({ type: 'getProduct' });
      yield put({ type: 'getVolume' });
    },
    /**
     * 获取固定运力
    */
    *getVolume(_, { call, put, select }) {
      let centerFilter = yield select(({ centerDepartBoard }) => centerDepartBoard.searchParams.centerFilter);
      let nextSite = yield select(({ centerDepartBoardModals }) => centerDepartBoardModals.modalTitle);
      const arr = [6, 7, 1];
      let periodObj = {};
      for (let i = 0; i < arr.length; i++) {
        const departure = yield call(crudRequest2, {
          arrivalCenter: nextSite,
          departureCenter: centerFilter,
          period: arr[i],
        });
        if (departure && departure.code === 1) {
          periodObj[`v${arr[i]}`] = departure.data && departure.data.length > 0 ? departure.data[0].volumes : 0
        }
      }
      yield put({
        type: 'update',
        payload: {
          volumes: periodObj
        },
      });
    },
    *getSiteDepart(_, { call, put, select }) {
      let centerFilter = yield select(({ centerDepartBoard }) => centerDepartBoard.searchParams.centerFilter);
      let query = yield select(({ centerDepartBoardModals }) => {
        return {
          dateType: centerDepartBoardModals.dateType,
          startDate: moment(centerDepartBoardModals.dateRange[0]),
          endDate: moment(centerDepartBoardModals.dateRange[1]),
          nextSite: centerDepartBoardModals.modalTitle
        }
      });
      // 获取网点运力
      const arr = [6, 7, 1];
      let periodObj = {};
      for (let i = 0; i < arr.length; i++) {
        const departure = yield call(crudRequest2, {
          arrivalCenter: query.nextSite,
          departureCenter: centerFilter,
          period: arr[i],
        });
        if (departure && departure.code === 1) {
          periodObj[`v${arr[i]}`] = departure.data && departure.data.length > 0 ? departure.data[0].volumes : 0
        }
      }

      const filter = VolumesQuery({
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        scanSite: centerFilter,
        type: query.dateType,
        nextSite: query.nextSite
      });
      const params = {
        aggregators: SqlBase(),
      }
      const data = yield call(getTimestampData, { ...params, ...filter[0] });
      const items = [];
      const items2 = [];
      data && data.forEach(item => {
        // const date = 
        let dow = moment(item.timestamp).day();
        if (dow === 6) {
          dow = 6;
        } else if (dow === 0) {
          dow = 7;
        } else {
          dow = 1
        }
        const volume = periodObj[`v${dow}`];
        const goodsWeight = item.goodsWeight ? (Math.abs(item.goodsWeight) / 1000).toFixed(2) : 0;
        const time = moment(item.timestamp).format('YYYY-MM-DD');
        items.push({
          name: time,
          value: goodsWeight
        })
        items2.push({
          name: time,
          value: volume
        })
      });
      yield put({
        type: 'update',
        payload: {
          totalData: items,
          volumesData: items2
        },
      });
    },
    /**
     * 产品类型数据统计
    */
    *getProduct(_, { call, put, select }) {
      let centerFilter = yield select(({ centerDepartBoard }) => centerDepartBoard.searchParams.centerFilter);
      let query = yield select(({ centerDepartBoardModals }) => {
        return {
          startDate: moment(centerDepartBoardModals.dateRange[0]),
          endDate: moment(centerDepartBoardModals.dateRange[1]),
          nextSite: centerDepartBoardModals.modalTitle
        }
      });

      const params = {
        simpleGranularity: 'all',
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        aggregators: SqlBase(),
      }
      const filter = VolumesQuery({
        startDate: query.startDate.format('YYYY-MM-DD 12:00:00'),
        endDate: query.endDate.format('YYYY-MM-DD 12:00:00'),
        scanSite: centerFilter,
        nextSite: query.nextSite
      });
      const items = [];
      const typeFilter = filter[1];
      for (let i = 0; i < typeFilter.length; i++) {
        const data = yield call(getData, { ...params, ...typeFilter[i] });
        let result = data[0] || null;
        const name = typeFilter[i].andFilters[0].value;
        const goodsWeight = result ? (Math.abs(result.goodsWeight) / 1000).toFixed(2) : 0;
        items.push({
          name: name,
          value: goodsWeight
        })
      }
      yield put({
        type: 'update',
        payload: {
          productData: items,
        },
      });
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
}